module.exports = __webpack_public_path__ + "180f7c9f95c4f613ea2172d6f1906c36.svg";